import { Requester } from "./requester";

export let Txt: BaseTranslation;

export async function TxtInitialize(language: string): Promise<any>
{
    Txt = await Requester.get(Requester.getUrl("public/translations", { language: language }));
}

export enum Language {
    english = "en-GB",
    estonian = "et-EE",
    russian = "ru-RU",
    latvian = "lv-LV",
    lithuanian = "lt-LT",
    finnish = "fi-FI"
}

interface BaseTranslation {
    monthNames: string[];
    dayNamesShort: string[];

    abbreviationHelp: string;
    add: string;
    addComment: string;
    all: string;
    allDayText: string;
    areYouSure: string;
    browse: string;
    cancel: string;
    comment: string;
    change: string;
    changeForm: string;
    changeRowComment: string;
    choose: string;
    chooseDesk: string;
    clear: string;
    clearLocation: string;
    close: string;
    confirmDeskSelection: string;
    continueWithoutChoosingDesk: string;
    copy: string;
    day: string;
    displayed: string;
    downloadApp: string;
    edit: string;
    employee: string;
    employeeBasedCalendar: string;
    endLocation: string;
    fileUploadFailed: string;
    fileUploadNotFinished: string;
    fileUploadSuccessful: string;
    filters: string;
    hidden: string;
    hideShortcuts: string;
    imagePreview: string;
    locationOnMap: string;
    locationSelectionDescription: string;
    logInAgain: string;
    logout: string;
    month: string;
    moreUppercase: string;
    nameless: string;
    networkError: string;
    newPassword: string;
    no: string;
    noEditFormAvailable: string;
    noMessages: string;
    noRecords: string;
    noResults: string;
    notifications: string;
    objectLocation: string;
    onlyJpg: string;
    over25MB: string;
    password: string;
    passwordsDontMatch: string;
    paste: string;
    pleaseTryAgain: string;
    profile: string;
    project: string;
    projectBasedCalendar: string;
    projectLocation: string;
    radius: string;
    rangeCurrentMonth: string;
    rangeLast7days: string;
    rangeLastMonth: string;
    rangeNext7days: string;
    rangeNextMonth: string;
    rangeToday: string;
    rangeTomorrow: string;
    rangeYesterday: string;
    rangePreviousQuarter: string;
    rangeCurrentQuarter: string;
    remove: string;
    removeDeskBooking: string;
    repeatPassword: string;
    save: string;
    searchLocation: string;
    search: string;
    selectAll: string;
    selectLocation: string;
    sessionHasExpired: string;
    showAll: string;
    showShortcuts: string;
    someError: string;
    startLocation: string;
    startLogging: string;
    stopLogging: string;
    invalidValueInsertedInTimesheet: string;
    cannotInsertThisShortcutToThisRowInTimesheet: string;
    cannotInsertWorkToThisRowInTimesheet: string;
    timesheetEditWarning: string;
    timesheetMassDeleteNotAllowed: string;
    toDashboard: string;
    today: string;
    unselectAll: string;
    mainData: string;
    vactionAndShiftLegend: string;
    waitingGPS: string;
    week: string;
    year: string;
    yes: string;
}
